module.exports = __webpack_public_path__ + "img/DASHBOARD.bde4d251.svg";